module.exports = __webpack_public_path__ + "static/media/home-light.2b45eda5.12e82634.svg";